module.exports = __webpack_public_path__ + "4450601e6bf183fb7e24491ec1341c21.pdf";